import React__default from 'react';

function Tab(_a) {
    var label = _a.label, children = _a.children, classes = _a.classes;
    return (React__default.createElement("div", { className: classes, "data-title": label }, children));
}

export { Tab as default };
//# sourceMappingURL=tab.component.js.map
